import { useTranslations } from '@vocab/react';
import { Text, TextLinkButton, IconDownload } from 'braid-design-system';

import translations from './DownloadLink.vocab';

interface Props {
  fileName: string;
  label: 'resume' | 'cover letter';
  automation: string;
  onClick: () => void;
}

export const DownloadLink = ({
  fileName,
  label,
  onClick,
  automation,
}: Props) => {
  const { t } = useTranslations(translations);
  const documentType = t(label);

  if (fileName) {
    return (
      <Text>
        <TextLinkButton
          data={{ automation }}
          onClick={onClick}
          icon={<IconDownload />}
        >
          {fileName}
        </TextLinkButton>
      </Text>
    );
  }

  return (
    <Text data={{ automation }} tone="secondary">
      {<IconDownload />} {t('No submitted', { label: documentType })}
    </Text>
  );
};
